import { IBaseSectionType } from './types';
import StyledTextArea from '~/components/StyledTextArea';
import Text from '~/components/Text';
import Gap from '~/components/Gap';
import styles from './estimateform.module.scss';

const NotesSection = ({ setValue, formData }: IBaseSectionType) => {
  return (
    <div className={styles.notesContainer}>
      <div className={styles.outInput}>
        <Text size="xs">Notes</Text>
        <Gap t={4} />
        <StyledTextArea
          value={formData.notes}
          onChange={e => setValue({ notes: e.target.value })}
          className={styles.notesText}
          rows={4}
          placeholder="Notes or payment details"
        />
        <Gap t={6} />
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={formData.saveNotesAsDefault}
            onChange={e => setValue({ saveNotesAsDefault: e.target.checked })}
          />
          <Text size="xs">Save as the default Notes for future estimates</Text>
        </label>
      </div>

      <Gap t={12} />

      <div className={styles.outInput}>
        <Text size="xs">Terms and Conditions</Text>
        <Gap t={4} />
        <StyledTextArea
          value={formData.terms}
          onChange={e => setValue({ terms: e.target.value })}
          className={styles.notesText}
          rows={4}
        />
        <Gap t={8} />
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={formData.saveTermsAsDefault}
            onChange={e => setValue({ saveTermsAsDefault: e.target.checked })}
          />
          <Text size="xs">Save as the default Terms and Conditions for future estimates</Text>
        </label>
      </div>
    </div>
  );
};

export default NotesSection;
